import { createAction } from 'redux-actions-helpers';

export const getSportsSuccess = createAction('@@sports/GET_SUCCESS', (items) => ({
    items
}));

export const sportsReorder = createAction('@@sports/REORDER', ({ startIndex, endIndex }) => ({
    startIndex,
    endIndex
}));

export const sportsSelect = createAction('@@sports/SELECT', (id) => ({
    id
}));

export const sportsVisible = createAction('@@sports/VISIBLE', (isVisible) => ({
    isVisible
}));

export const setCountTotalSports = createAction('@@sports/SET_COUNT_TOTAL_SPORTS', (total) => ({
    total
}));



// WEBPACK FOOTER //
// ./src/blocks/sports/actions.js